import React from 'react';
import SingleButton from './SingleButton';
import { green } from '@mui/material/colors';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';

function SaveButton({ disabled }) {
  return (
    <SingleButton
      variant="contained"
      bgColor={green[800]}
      textColor="#fff"
      hoverColor={green[700]}
      startIcon={<SaveOutlinedIcon sx={{ color: 'white' }} />}
      type="submit"
      disabled={disabled}
    >
      Salvar
    </SingleButton>
  );
}

export default SaveButton;
